import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import Donation from '../components/Donation';
import './GetInvolvedPage.css';

const GetInvolvedPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="get-involved-page">
      <div className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <h1 className="page-title">
              {t.getInvolvedTitle}
            </h1>
            <p className="page-subtitle">
              {t.getInvolvedSubtitle}
            </p>
          </div>
        </div>
      </div>
      
      <Donation />
    </div>
  );
};

export default GetInvolvedPage;
